export default{
  // New Users
  engagement_retention_retention: '留存',
  engagement_retention_newusers: '新进留存分析',
  engagement_retention_activeUsers: '活跃留存分析',
  engagement_retention_d237RetentionNewUsers: '新进用户次留/3留/7留',
  pc_engagement_retention_d237RetentionNewUsers: '新进用户次留/2留/3留/7留',
  engagement_retention_newUsersRetention: '新进用户留存',
  engagement_retention_averaged1: '平均次留', // 夜莺的D1是次留，D2是二留
  pc_engagement_retention_averaged1: '平均次留',
  pc_engagement_retention_averaged2: '平均2留',
  engagement_retention_nightingale_averaged2: '平均2留', // 夜莺的D1是次留，D2是二留
  engagement_retention_averaged2: '平均次留',
  engagement_retention_averaged3: '平均3留',
  engagement_retention_averaged7: '平均7留',
  engagement_retention_retentionNewUsers: '新进用户留存',
  engagement_retention_date: '日期',
  engagement_retention_register: '注册',
  engagement_retention_d: '{num}留',
  engagement_retention_d_new: 'D{num}留存',
  engagement_retention_d1: '次留',// 夜莺的D1是次留，D2是2留
  engagement_retention_d2: '次留',
  pc_engagement_retention_d1: '次留',
  pc_engagement_retention_d2: '2留',
  engagement_retention_nightingale_d2: '2留',// 夜莺的D1是次留，D2是2留
  engagement_retention_d3: '3留',
  engagement_retention_d4: '4留',
  engagement_retention_d5: '5留',
  engagement_retention_d6: '6留',
  engagement_retention_d7: '7留',
  engagement_retention_d14: '14留',
  engagement_retention_d30: '30留',
  engagement_retention_d60: '60留',

  engagement_retention_w: '{num}周留存',
  engagement_retention_w_new: 'W{num}留存',
  engagement_retention_w2: '次周留存',
  engagement_retention_w3: '3周留存',
  engagement_retention_w4: '4周留存',
  engagement_retention_w5: '5周留存',
  engagement_retention_w6: '6周留存',
  engagement_retention_w7: '7周留存',
  engagement_retention_w14: '14周留存',
  engagement_retention_w30: '30周留存',
  engagement_retention_w60: '60周留存',

  engagement_retention_m: '{num}月留存',
  engagement_retention_m_new: 'M{num}留存',
  engagement_retention_m2: '次月留存',
  engagement_retention_m3: '3月留存',
  engagement_retention_m4: '4月留存',
  engagement_retention_m5: '5月留存',
  engagement_retention_m6: '6月留存',
  engagement_retention_m7: '7月留存',
  engagement_retention_m14: '14月留存',
  engagement_retention_m30: '30月留存',
  engagement_retention_m60: '60月留存',

  engagement_retention_percentage: '百分比 ',
  engagement_retention_keydays: '关键日',
  engagement_retention_230days: '1 ~ 30 日',
  engagement_retention_260days: '1 ~ 60 日',
  engagement_retention_290days: '1 ~ 90 日',
  engagement_retention_2180days: '1 ~ 180 日',
  engagement_retention_2360days: '1 ~ 360 日',
  // Active Users
  engagement_retention_d237retentionactiveusers: '次留/3留/7留 留存活跃用户',
  pc_engagement_retention_d237retentionactiveusers: '次留/2留/3留/7留 留存活跃用户',
  engagement_retention_activeusersretention: '活跃用户留存',
  engagement_retention_retentionActiveUsers: '活跃用户留存',
  engagement_retentionactiveUsers: '活跃用户',

  engagement_retention_user: '留存用户',
  engagement_retention_rate: '留存率',
  engagement_retention_average: '加权留存值',

  engagement_retention_d1d237_retention_new_users: '新进用户次留/2留/3留/7留',
  engagement_retention_d1d237_return_retention_actve_users: '活跃用户次留/2留/3留/7留',
  engagement_retention_d1d237_roll_retention_new_users: '新进用户滚动次留/2留/3留/7留',
  engagement_retention_d1d237_roll_retention_active_users: '活跃用户滚动次留/2留/3留/7留',
  engagement_retention_return_rate_new_users: '新进用户留存率',
  engagement_retention_return_rate_active_users: '活跃用户留存率',
  engagement_retention_roll_rate_new_users: '新进用户滚动留存率',
  engagement_retention_roll_rate_active_users: '活跃用户滚动留存率',
 
};
